import { Address } from 'viem';

export enum SortDestination {
  Asc = 'ASC',
  Desc = 'DESC',
}

export const PERCENT_DIVIDER = 100;

export const WHITE_LIST_ADDRESS = [
  '0xdd035e4a299fAFFe584d459F6d86C23fFBD6D3f0',
  '0xCF345506097f1F67Ee87108491a74c4194489A29',
  '0xc9c5fAb8C795BA16cc523Bbef8030807D1421F98',
  '0x0f1B97170118ae387cF5A29578E68E5D78433813',
  '0xa845a58724CF44698510c92b690BA1484c26AD3B',
  '0x2A4Cdc9bBd937023A95E50185c0c027647f5a7b5',
  '0x1653a8ec77eb8ea6bbbd2e9af71a053a437083d0',
  '0xBfd8194f7cC17D2f4f324E440F47571D845bcfFF',
];

export const ADMINS_LIST_ADDRESS = [
  '0xdd035e4a299fAFFe584d459F6d86C23fFBD6D3f0',
  '0xCF345506097f1F67Ee87108491a74c4194489A29',
  '0xc9c5fAb8C795BA16cc523Bbef8030807D1421F98',
  '0x0f1B97170118ae387cF5A29578E68E5D78433813',
  '0xBfd8194f7cC17D2f4f324E440F47571D845bcfFF',
  '0xa845a58724CF44698510c92b690BA1484c26AD3B',
  '0x2A4Cdc9bBd937023A95E50185c0c027647f5a7b5',
  '0x1653a8ec77eb8ea6bbbd2e9af71a053a437083d0',
  '0x9649212DEDf68F87971fbee2b8C847F6300efB8d',
  '0x4F662E0F8956B59BECE1504BFA4c73485cE009F1',
] as Address[];
